import { Redirect, Route } from "react-router-dom";
import { MARKETPLACE_GWT} from '@marketplace/common'

export function ProtectedRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem(MARKETPLACE_GWT);

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to='/login'/>
      }
    />
  );
}